<div class="help-modal-overlay" (click)="onClose()">
  <div class="help-modal-container" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="modal-header">
      <div class="modal-header-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M12 16v-4"></path>
          <path d="M12 8h.01"></path>
        </svg>
      </div>
      <h2 class="modal-title">Help & Support</h2>
      <button (click)="onClose()" class="modal-close-btn" type="button" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <p class="guidance-text">
        For any application issues, please kindly contact the Administrator
        (MAT Coordinator) using the email address provided below.
      </p>

      <div class="email-box">
        <span class="email-box-label">Support Email</span>
        <div class="email-box-row">
          <a [href]="'mailto:' + adminEmail" class="email-link">{{ adminEmail }}</a>
          <button
            (click)="copyToClipboard(adminEmail)"
            class="copy-btn"
            type="button"
            [title]="copySuccess ? 'Copied!' : 'Copy to clipboard'">
            <svg *ngIf="!copySuccess" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
            </svg>
            <svg *ngIf="copySuccess" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <span>{{ copySuccess ? 'Copied!' : 'Copy' }}</span>
          </button>
        </div>
      </div>

      <p class="email-note">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        Emails will not be sent directly from the application. Please initiate communication externally using your email client.
      </p>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button (click)="onClose()" class="btn-close-modal" type="button">Close</button>
    </div>

  </div>
</div>

